<template>
    <div class="text-center">
      <v-dialog
        v-model="modalStatus"
        max-width="650"
        scrollable
        persistent
      >
        <v-card>
          <v-card-text class="pa-0">
            <div class="py-4 px-8">
              <!-- Título -->
              <div class="d-flex flex-row align-center justify-space-between mb-4">
                <div class="d-flex align-center">
                  <v-icon color="#2D4B95" class="mr-2" size="28">mdi-file-cad-box</v-icon>
                  <p class="mb-0 font-weight-bold text-primary title">Agregar Plano</p>
                </div>
                <v-btn icon small @click="closeModal()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>

              <!-- Campo Título -->
              <v-row class="mb-3">
                <v-col cols="12">
                  <v-text-field
                    v-model="newPlano.title"
                    label="Título del plano"
                    placeholder="Ej: Plano Arquitectónico Nivel 1"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                    prepend-inner-icon="mdi-tag-outline"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Tipo de archivo -->
              <v-row class="mb-3">
                <v-col cols="12">
                  <div class="file-mode-section">
                    <p class="mb-2 subtitle-2 font-weight-medium grey--text text--darken-2">
                      <v-icon small class="mr-1">mdi-file-document-outline</v-icon>
                      Origen del archivo
                    </p>
                    <v-chip-group v-model="fileMode" mandatory active-class="primary--text">
                      <v-chip value="forge" outlined color="#2D4B95" class="px-4">
                        <v-icon small class="mr-2">mdi-cube-scan</v-icon>
                        Modelo 3D / Plano Forge
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-col>
              </v-row>

              <!-- Modo Local -->
              <v-row v-if="fileMode === 'local'">
                <v-col cols="12">
                  <div class="d-flex flex-column">
                    <img v-if="previewImage" :src="previewImage" class="preview-img mb-2"/>
                    <v-btn
                      v-if="!previewImage"
                      class="mx-0 my-1"
                      rounded
                      color="white"
                      raised
                      @click="onButtonClick"
                    >
                      <v-icon small class="mr-1" color="#2D4B95">mdi-paperclip</v-icon>
                      <p class="mb-0 text-primary">Adjuntar Archivo</p>
                    </v-btn>
                    <div v-if="!previewImage" class="caption grey--text text--darken-1 mt-1">Formatos permitidos: .pdf, .png, .jpg</div>
                    <v-btn
                      v-if="previewImage"
                      x-small
                      text
                      color="red"
                      class="mx-0 mt-1 align-self-start"
                      @click="clearLocalFile"
                    >
                      <v-icon x-small class="mr-1">mdi-close</v-icon>Quitar archivo
                    </v-btn>
                    <input
                      ref="uploader"
                      class="d-none"
                      type="file"
                      accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
                      @change="onFileChanged"
                    >
                  </div>
                </v-col>
              </v-row>

              <!-- Modo Forge -->
              <v-row v-if="fileMode === 'forge'">
                <v-col cols="12">
                  <v-card outlined class="forge-section pa-3">
                    <v-autocomplete
                      v-model="selectedForgeFile"
                      :loading="$store.forgeStore.state.loadingFiles"
                      :items="$store.forgeStore.state.forgeFiles"
                      :item-disabled="isFileDisabled"
                      item-text="name"
                      item-value="id"
                      return-object
                      outlined
                      dense
                      label="Seleccionar modelo/plano disponible"
                      hide-details="auto"
                      placeholder="Buscar en archivos procesados..."
                      prepend-inner-icon="mdi-magnify"
                      clearable
                      class="mb-3"
                    >
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-bind="attrs" v-on="on" :disabled="isFileDisabled(item)">
                        <v-list-item-avatar size="40" :color="isFileDisabled(item) ? 'grey lighten-3' : 'blue lighten-5'" rounded>
                          <v-icon :color="isFileDisabled(item) ? 'grey lighten-1' : 'blue darken-1'" size="20">
                            {{ isFileProcessing(item) ? 'mdi-progress-clock' : 'mdi-file-cad' }}
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title :class="isFileDisabled(item) ? 'grey--text' : 'font-weight-medium'">
                            {{ item.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="isFileProcessing(item)" class="d-flex align-center mt-1">
                            <v-chip x-small color="orange lighten-4" text-color="orange darken-3" class="mr-2">
                              <v-icon x-small left>mdi-clock-outline</v-icon>Procesando
                            </v-chip>
                            <span class="caption grey--text">Intenta en unos minutos</span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-else-if="!isFileDisabled(item)" class="d-flex align-center mt-1">
                            <v-chip x-small color="green lighten-4" text-color="green darken-3">
                              <v-icon x-small left>mdi-check-circle</v-icon>Listo para usar
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content class="text-center py-4">
                          <v-icon size="48" color="grey lighten-1" class="mb-2">mdi-file-search-outline</v-icon>
                          <v-list-item-title class="grey--text">
                            No se encontraron archivos procesados
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption mt-1">
                            Usa el botón de abajo para agregar un archivo
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <v-divider class="mb-3"></v-divider>

                  <div class="text-center">
                    <p class="caption grey--text text--darken-1 mb-2">
                      ¿No encuentras el archivo? Disponibilízalo desde tu biblioteca
                    </p>
                    <v-btn
                      outlined
                      color="#2D4B95"
                      :loading="forgeSelectionLoading || forgeExtensionsLoading"
                      @click="openFileSelector"
                      class="forge-action-btn"
                    >
                      <v-icon left>mdi-folder-search-outline</v-icon>
                      Disponibilizar archivo
                    </v-btn>
                  </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Acciones -->
              <v-divider class="my-4"></v-divider>
              <v-row>
                <v-col cols="12">
                  <div class="d-flex justify-end">
                    <v-btn text color="grey darken-1" class="mr-2" @click="closeModal()" :disabled="loading">
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="#2D4B95"
                      dark
                      elevation="0"
                      :loading="loading"
                      @click="savePlano()"
                      large
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Guardar plano
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <FileSelectorModal
        v-if="showFileSelector"
        :file-filter="isForgeItem"
        @select="onFileSelected"
        @close="showFileSelector = false"
      />
    </div>
</template>
  
  <script>
  import { v4 as uuidv4 } from 'uuid'
  import EventBus from '@/helpers/event_bus'
  import { addPlano, markForgeFileAsBlueprint } from '@/helpers/api/entrega'
  import { getFile } from '@/helpers/api/files'
  import { getSupportedExtensions, addFileToForge } from '@/helpers/api/forge'
  import { checkPermissions } from '@/helpers/permissions'
  import FileSelectorModal from '@/components/Globals/Modals/General/FileSelectorModal'
  import { isForgeItem as isForgeCompatible, isForgeProcessing, isForgeTranslated } from '@/helpers/forge'

  export default {
    name: 'AddPlanoModal',
    components: {
      FileSelectorModal
    },
    props: {
      closeModal: {
        type: Function,
        required: true
      },
      modalStatus: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        newPlano: {
          title: null,
        },
        fileMode: 'forge',
        selectedForgeFile: null,
        showFileSelector: false,
        forgeSupportedExtensions: [],
        forgeExtensionsLoading: false,
        forgeSelectionLoading: false,
        pendingForgeFileId: null,
        previewImage: null,
        files: [],
        loading: false,
        requiredRule: [v => !!v || 'Este campo es requerido'],
      }
    },
    watch: {
      modalStatus(val) {
        if (val) {
          this.loadForgeFiles();
        } else {
          this.resetForm();
        }
      },
      fileMode() {
        this.clearLocalFile();
        this.selectedForgeFile = null;
      }
    },
    mounted() {
      if (this.modalStatus) {
        this.loadForgeFiles();
      }
      this.loadForgeSupportedExtensions();
      EventBus.$on('completedFileUpload', this.handleForgeUploadComplete);
    },
    beforeDestroy() {
      EventBus.$off('completedFileUpload', this.handleForgeUploadComplete);
    },
    methods: {
      loadForgeFiles() {
        const projectId = this.$store.projectsStore.state.selectedProject?.id;
        if (projectId) {
          return this.$store.forgeStore.dispatch('fetchForgeFiles', { project_id: projectId });
        }
        return Promise.resolve(null);
      },
      async loadForgeSupportedExtensions() {
        if (this.forgeSupportedExtensions.length || this.forgeExtensionsLoading) return;

        this.forgeExtensionsLoading = true;
        try {
          const response = await getSupportedExtensions();
          if (response.code === 200 && Array.isArray(response.supported_extensions)) {
            this.forgeSupportedExtensions = response.supported_extensions;
          }
        } catch (error) {
          console.error('Error al cargar extensiones de Forge:', error);
        } finally {
          this.forgeExtensionsLoading = false;
        }
      },
      resetForm() {
        this.newPlano = { title: null };
        this.fileMode = 'forge';
        this.selectedForgeFile = null;
        this.showFileSelector = false;
        this.pendingForgeFileId = null;
        this.forgeSelectionLoading = false;
        this.previewImage = null;
        this.files = [];
      },
      isFileProcessing(file) {
        return isForgeProcessing(file) || !isForgeTranslated(file);
      },
      isFileDisabled(file) {
        return this.isFileProcessing(file);
      },
      isForgeItem(file) {
        return isForgeCompatible(file, this.forgeSupportedExtensions);
      },
      async openFileSelector() {
        await this.loadForgeSupportedExtensions();
        this.showFileSelector = true;
      },
      onFileSelected(file) {
        this.showFileSelector = false;

        if (!this.isForgeItem(file)) {
          this.showMessage({
            message: 'El archivo seleccionado no es compatible con Autodesk Forge.',
            title: 'Archivo no compatible',
            type: 'error'
          });
          return;
        }

        if (this.fileMode !== 'forge') {
          this.fileMode = 'forge';
          this.$nextTick(() => this.handleForgeFileSelected(file));
          return;
        }

        this.handleForgeFileSelected(file);
      },
      async handleForgeFileSelected(file) {
        this.selectedForgeFile = null;
        this.pendingForgeFileId = file.id;

        if (!this.checkPermission('send_to_autodesk', 'disponibilizar el plano/modelo')) {
          this.pendingForgeFileId = null;
          return;
        }

        this.forgeSelectionLoading = true;
        try {
          const projectId = this.$store.projectsStore.state.selectedProject.id;
          const blueprintResponse = await markForgeFileAsBlueprint({
            project_id: projectId,
            file_id: file.id
          });

          if (blueprintResponse.code !== 200) {
            throw new Error('No fue posible marcar el archivo como plano/modelo Forge');
          }

          const forgeFile = blueprintResponse.forge_file;
          const markedFile = forgeFile ? { ...file, forge_file: forgeFile } : file;

          if (isForgeTranslated(markedFile)) {
            this.pendingForgeFileId = null;
            await this.refreshForgeSelection(markedFile);
            return;
          }

          if (isForgeProcessing(markedFile)) {
            this.showMessage({
              message: 'Este archivo ya está siendo procesado para Autodesk Forge.',
              title: 'Archivo en proceso',
              type: 'warning'
            });
            return;
          }

          const response = await addFileToForge({ file_id: file.id });
          if (response.code === 200) {
            const fileName = file.name || file.title || `Archivo ${file.id}`
            this.$store.globalStore.commit('setForgeProcessingFile', {
              file_id: file.id,
              file_name: fileName,
              title: fileName
            });
          } else {
            this.pendingForgeFileId = null;
            this.showMessage({ message: 'No fue posible enviar el archivo a Forge.', title: 'Error', type: 'error' });
          }
        } catch (error) {
          this.pendingForgeFileId = null;
          console.error('Error al enviar archivo a Forge:', error);
          this.showMessage({ message: 'Error al enviar el archivo a Forge.', title: 'Error', type: 'error' });
        } finally {
          this.forgeSelectionLoading = false;
        }
      },
      async refreshForgeSelection(file) {
        await this.loadForgeFiles();
        const forgeFiles = this.$store.forgeStore.state.forgeFiles || [];
        const refreshedFile = forgeFiles.find(f => `${f.id}` === `${file.id}`);
        this.selectedForgeFile = refreshedFile || file;
        return this.selectedForgeFile;
      },
      async handleForgeUploadComplete() {
        if (!this.pendingForgeFileId) return;

        const pendingFileId = this.pendingForgeFileId;
        try {
          const response = await getFile({ file_id: pendingFileId });
          const file = response.code === 200 ? response.data : null;
          if (!isForgeTranslated(file)) return;

          await this.refreshForgeSelection(file);
          this.pendingForgeFileId = null;
          this.showMessage({
            message: 'El plano/modelo ya está disponible para seleccionarlo.',
            title: 'Archivo disponible',
            type: 'success'
          });
        } catch (error) {
          console.error('Error al actualizar el archivo Forge:', error);
        }
      },
      clearLocalFile() {
        this.previewImage = null;
        this.files = [];
        if (this.$refs.uploader) {
          this.$refs.uploader.value = '';
        }
      },
      toBase64(file) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
        });
      },
      onButtonClick() {
        this.$refs.uploader.click();
      },
      async onFileChanged(e) {
        const newFile = e.target.files[0];
        if (!newFile) return;
        this.files = [newFile];
        if (newFile.type.includes('image')) {
          this.previewImage = await this.toBase64(newFile);
        } else {
          this.previewImage = null;
        }
      },
      async savePlano() {
        if (!this.newPlano.title) {
          this.showMessage({ message: 'Por favor escribe un título. Este campo no puede estar vacío.', title: 'Error', type: 'error' });
          return;
        }

        if (this.fileMode === 'local' && this.files.length === 0) {
          this.showMessage({ message: 'Por favor adjunta un archivo.', title: 'Error', type: 'error' });
          return;
        }

        if (this.fileMode === 'forge' && (!this.selectedForgeFile || !isForgeTranslated(this.selectedForgeFile))) {
          this.showMessage({ message: 'Selecciona un archivo de Forge que ya esté traducido.', title: 'Error', type: 'error' });
          return;
        }

        this.loading = true;
        const projectId = this.$store.projectsStore.state.selectedProject.id;

        try {
          if (this.fileMode === 'forge') {
            // Enviar solo project_id, title y file_id
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('title', this.newPlano.title);
            formData.append('file_id', this.selectedForgeFile.id);

            const plano = await addPlano(formData);
            if (plano.code === 200) {
              this.showMessage({ message: 'Plano creado correctamente', title: 'Éxito', type: 'success' });
            }
          } else {
            // Enviar archivos local
            const formData = new FormData();
            formData.append('project_id', projectId);
            formData.append('title', this.newPlano.title);

            const biggerFiles = [];
            this.files.forEach((file) => {
              if (file && file.size < 100000) {
                formData.append('files[]', file);
              } else if (file) {
                biggerFiles.push({
                  type: 9,
                  payload: null,
                  description: this.newPlano.title,
                  total: file.size,
                  uuid: uuidv4(),
                  file,
                });
              }
            });

            const plano = await addPlano(formData);
            if (plano.code === 200) {
              if (biggerFiles.length > 0) {
                biggerFiles.forEach(f => {
                  f.item_id = plano.plano.id;
                  f.payload = { plano_id: plano.plano.id, project_id: projectId };
                  this.$store.globalStore.commit('setFilesToUploadCenter', f);
                });
              }
              this.showMessage({ message: 'Plano creado correctamente', title: 'Éxito', type: 'success' });
            }
          }

          this.closeModal();
          this.$store.entregaStore.dispatch('getPlanos', { project_id: projectId });
        } catch (error) {
          console.error('Error al guardar plano:', error);
          this.showMessage({ message: 'Error al guardar el plano', title: 'Error', type: 'error' });
        } finally {
          this.loading = false;
        }
      },
      checkPermission(permissionsToCheck, actionName) {
        if (!checkPermissions(Array.isArray(permissionsToCheck) ? permissionsToCheck : [permissionsToCheck])) {
          this.showMessage({
            message: `No tienes permisos para ${actionName || 'realizar esta acción'}.`,
            title: 'Acceso denegado',
            type: 'warning'
          });
          return false;
        }
        return true;
      },
      showMessage(data) {
        this.$store.globalStore.dispatch('addMessage', {
          message: data.message,
          title: data.title || 'Notificación',
          created: new Date(),
          type: data.type || 'info',
          icon: data.type === 'error' ? 'mdi-alert-circle' : 'mdi-check-circle',
          color: data.type === 'error' ? '#fb8c00' : '#4CAF50'
        });
      }
    }
  };
  </script>
  
  <style scoped>
    .file-mode-section {
      background: #f8f9fa;
      padding: 12px;
      border-radius: 8px;
    }
    .forge-section {
      background: #fafbfc;
      border: 1px solid #e1e4e8 !important;
      border-radius: 8px;
    }
    .forge-action-btn {
      text-transform: none;
      font-weight: 500;
      letter-spacing: 0.25px;
    }
    .info-container{
      color: #606060;
    }
    .text-primary{
      color: #2D4B95;
    }
    .info-icon{
      background-color: #2D4B95;
      border-radius: 25px;
      padding: 3px;
      width: 35px;
      height: 35px;
    }
    .info-icon.small-icon{
      width: 25px;
      height: 25px;
    }
    .info-img{
      width: 100%;
      max-height: 50px;
      object-fit: contain;
    }
    .adjuntos-container{
      background-color: #EFEFEF;
      max-height: 95px;
      overflow-y: scroll;
    }
    .interaction-container{
      width: 100%;
      background-color: #E5E9F2;
      border-radius: 5px;
      position: relative;
      padding: 12px;
    }
    .interaction-container.response{
      background-color: #CAE7CC;
    }
    .user-avatar.small{
      width: 25px;
      height: 25px;
    }
    .light-blue-text{color: #5E85EF;}
    .interaction-container .icon-arrow{
      font-size: 80px;
      position: absolute;
      top: 20px;
      line-height: inherit;
    }
    .interaction-container.right .icon-arrow{
      left: -46px;
    }
    .interaction-container.left .icon-arrow{
      right: -46px;
    }
    .icon-top{
      padding: 2px;
      margin: 0 2px;
      border-radius: 100%;
    }
    .icon-top.high{
      background-color: #F4516C;
    }
    .icon-top.medium{
      background-color: #fb8c00;
    }
    .icon-top.normal{
      background-color: #3EBFA3;
    }
    .icon-top.primary{
      background-color: #2D4B95;
    }
    .icon-top.light-blue{
      background-color: #5E85EF;
    }
    .parent-subtareas{
      display: flex;
      flex-wrap: wrap;
    }
    .parent-subtareas .subtareas-checkbox{
      flex: 1 0 30%;
    }
    .notification-img{
      width: 30px;
      height: 30px;
      border-radius: 100%;
    }
    .preview-img-container{
      position: relative;
    }
    .preview-img{
      width: 100%;
      height: auto;
      border-radius: 10px;
      object-fit: contain;
    }
    .button-preview-img{
      position: absolute;
      top: -1px;
      left: -1px;
      background-color: white;
    }
  </style>